import React, { memo, useEffect, useMemo, useRef, useState } from 'react';
import "./queryList.css";
import FileIcon from '../../assets/icons/file.svg';
import { ROUTES, TOKENS } from '../../utilities/Constants/Constants';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setCheckedList, setDisplayItems } from '../../service/apiSlices/staticApi';
import ModelListItem from './modelListItem';
import EmptyContent from './emptyContent';
import PendingStatusModal from '../WorkbentchModel/prepareLoadingModel';
import WorkFlowPageLinkDeciderModal from '../WorkbentchModel/workbentchModel';
import { useGetRedirectionURLMutation, useModelListQuery } from '../../service/apiSlices/sematicModel';

const GeneratedQuery = ({ type, activeView, debouncedSearchText, alignQuery, isTabActive }: any) => {

  const { selectedAction, checkedList } = useSelector((state: any) => state.static)
  const [page, setPage] = useState(1);
  const [modelItemsPerPage, setModelItemsPerPage] = useState<number>(24);

  const [isLoading, setIsLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState([])
  const [allItems, setAllItems] = useState<any[]>([]);
  const [isScrolling, setIsScrolling] = useState(false);
  const [containerRef, setContainerRef] = useState<HTMLDivElement | null>(null);
  const [totalItems, setTotalItems] = useState(0);
  const [modalOpen, setModalOpen] = useState({ state: false, Id: "" });
  const [showPendingModal, setShowPendingModal] = useState(false);

  const dispatch = useDispatch()
  const location = useLocation()

  const connection_Id: any = sessionStorage.getItem(TOKENS.CONNECTION_ID)
  sessionStorage.removeItem("SemanticData")

  let modelPayload = {
    search: debouncedSearchText,
    page: page,
    limit: modelItemsPerPage,
    connection_key: connection_Id
  }
  const { data: getModelList, isFetching: isModelListLoading, refetch: modelRefetch } = useModelListQuery(modelPayload, {
    skip: !isTabActive || location.pathname !== ROUTES.QUERYLIST
  })

  const [getChatURL] = useGetRedirectionURLMutation();

  useEffect(() => {
    if (!isTabActive) return;

    setPage(1);
    modelRefetch();
  }, [debouncedSearchText, alignQuery, isTabActive]);

  useEffect(() => {
    if (!isTabActive) return;
    modelRefetch();
  }, [page, modelItemsPerPage]
  );
  useEffect(() => {
    dispatch(setDisplayItems((allItems?.length)))
  }, [allItems])

  useEffect(() => {
    if (!containerRef) return;

    const handleScroll = (e: any) => {
      if (isScrolling) {
        return;
      }

      const target = e.target as HTMLDivElement;
      const { scrollTop, scrollHeight, clientHeight } = target;

      if (scrollHeight - scrollTop <= clientHeight + 50) {
        if (modelItemsPerPage < totalItems) {
          setIsScrolling(true);
          setModelItemsPerPage(prev => {
            const newVal = Math.min(prev + 10, totalItems);
            setTimeout(() => setIsScrolling(false), 500);
            return newVal;
          });
        }
      }
    };

    containerRef.addEventListener("scroll", handleScroll);

    return () => {
      containerRef.removeEventListener("scroll", handleScroll);
    };
  }, [containerRef,
    isScrolling,
    totalItems,
    modelItemsPerPage]);

  useEffect(() => {
    if (getModelList?.data) {
      setAllItems(getModelList?.data);
      setTotalItems(getModelList?.data.total);
      setIsLoading(false);
    }

  }, [getModelList, isTabActive]);

  const handleItemClick = (item: any) => {
    setSelectedItem(item);
    if (item?.is_model_completed === true) {
      setModalOpen({ state: true, Id: item.secret_key });
    } else {
      setShowPendingModal(true);
    }
  };

  const handleModalChange = () => {
    setShowPendingModal(false);
    setModalOpen({ state: false, Id: "" });
  };

  const generateChatLink = (key: string) => {
    getChatURL({ key }).unwrap().then((response: any) => {
      if (response?.data) {
        window.open(response.data, "_blank");
      }
    });
  };

  const handleAllStatusCompleted = (id: string | number, data: any) => {
    setAllItems(allItems.map(item =>
      item._id === id ? { ...item, ...data } : item
    ));

    setShowPendingModal(false);
    setModalOpen({ state: true, Id: data._id || "" });
  };



  const handleListCheck = (item: any, checked: boolean) => {

    const id = item.secret_key;
    dispatch(setCheckedList({ id, checked, view: "semantic" }));

  }

  const isAnyLoading = isLoading || isModelListLoading

  return (
    <>
      <div className="models-list-container-model h-100 overflow-auto" ref={el => setContainerRef(el)} >
        {allItems.length === 0 &&
          <EmptyContent isLoading={isAnyLoading} itemsLength={allItems.length} />
        }
        {!isAnyLoading && allItems.length > 0 && (
          <div className="row modelsList-data-wrapper-row-list g-3 justify-content-start">
            {allItems.map((item: any) => {
              const id = item.id || item._id || item.secret_key;
              const name = item.name || item.workspace_name;

              return (
                <ModelListItem
                  key={id}
                  id={id}
                  name={name}
                  dateTime={item.created_on}
                  item={item}
                  isChecked={
                    checkedList.semantic.includes(item.secret_key)
                  }
                  showCheckbox={selectedAction === "check"}
                  onItemClick={handleItemClick}
                  onCheckboxClick={handleListCheck}
                  showPendingStatus={'is_model_completed' in item && !item['is_model_completed']}
                />
              )
            })}
          </div>)}

      </div>

      {selectedItem && showPendingModal && (
        <PendingStatusModal
          model={selectedItem}
          isVisible={showPendingModal}
          handleOnChange={handleModalChange}
          onAllStatusCompleted={handleAllStatusCompleted}
        />
      )}

      {selectedItem && modalOpen.state && (
        <WorkFlowPageLinkDeciderModal
          isVisible={modalOpen}
          onChange={handleModalChange}
          onGetURL={generateChatLink}
          selectedItem={selectedItem}
        />
      )}
    </>
  );
};


export default memo(GeneratedQuery);